<template>
	<div class="person">
		<back-to :title="title"></back-to>
		<section class="person_title">
			<h2>{{productList.title}}</h2>
			<img :src="picturePath" alt="">
		</section>
		<section class="person_origin">
			<span><label for="">套餐</label>
				<p>{{productListPackage.name}}</p>
			</span>
			<span><label for="">出发地</label>
				<p>{{productListPackage.pod}}</p>
			</span>
			<span><label for="">出发日期</label>
				<p>{{time}}</p>
			</span>
			<span class="personnum"><label for="">数量</label>
				<p v-for="(item,index) in enrollsList.enrolls" :key="index">{{item.enrollName}} * {{buyNum[index].num}}
				</p>
			</span>
		</section>
		<section class="person_info">
			<h2>订单联系人</h2>
			<van-cell-group>
				<van-field v-model="input_contact_name" label="联系人姓名" required placeholder="请输入姓名" />
				<van-field v-model="input_contact_people" label="联系人电话" required placeholder="请输入电话" type="tel" />
				<van-field v-model="input_contact_desc" label="备注" placeholder="请输入备注" />
			</van-cell-group>
		</section>
		<section class="person_chuxing">
			<span class="person_chuxing-title">
				<h2>出行人信息</h2><label for="" @click="goAdd">填写/修改</label>
			</span>
			<span class="person_chuxing-content">
				<section v-for="(item,index) in enrollsList.enrolls" :key="index">
					<label for="" v-for="(val,key) in buyNum[index].num" :key="key">
						<p>{{item.enrollName}}</p>
						<font v-if="buyNum[index].info.length > 0 && buyNum[index].info[key]">
							{{buyNum[index].info[key].name}}
						</font>
						<font v-else>游客{{key+1}}</font>
					</label>
				</section>
			</span>
		</section>
		<!-- 购买按钮 -->
		<section class="detailBottom">
			<span class="detailBottom_pric">
				<label for="">
					<font>总价</font>￥{{total_price}}
				</label>
			</span>
			<span class="" @click="onsubmit">提交订单</span>
		</section>
	</div>
</template>

<script>
	import {
		mapGetters,
		mapMutations
	} from 'vuex'
	import {
		_debounce
	} from '@/config/util'
	import {
		Dialog,
		Toast
	} from 'vant'
	import BackTo from "@/components/BackTo";
	export default {
		name: 'person',
		components: {
			BackTo
		},
		data() {
			return {
				title: "出行人",
				productList: [],
				packegeSelectIndex: 0,
				time: "",
				model_date_f: [],
				productListPackage: [],
				picturePath: "",
				buyNum: [],
				enrollsList: "",
				input_contact_name: "",
				input_contact_people: "",
				input_contact_desc: "",
				total_price: ""
			}
		},
		computed: {
			...mapGetters('account', ['buyNuminfo', 'contactinfo', 'userInfo'])
		},
		created() {
			this.time = this.$route.query.time
			this.total_price = this.$route.query.total_price
			this.packegeSelectIndex = this.$route.query.packegeSelectIndex
			this.childIndex = this.$route.query.childIndex
			if (localStorage.getItem('buyNuminfo')) {
				this.buyNum = this.buyNuminfo
			} else {
				this.buyNum = JSON.parse(this.$route.query.buyNum)
			}
			if (localStorage.getItem('contactinfo')) {
				this.input_contact_name = this.contactinfo.input_contact_name
				this.input_contact_people = this.contactinfo.input_contact_people
				this.input_contact_desc = this.contactinfo.input_contact_desc
			}
		},
		mounted() {
			this.getData()
		},
		methods: {
			...mapMutations('account', ['setContactinfo']),
			goAdd() {
				console.log(this.input_contact_name)
				this.setContactinfo({
					'input_contact_name': this.input_contact_name,
					'input_contact_desc': this.input_contact_desc,
					'input_contact_people': this.input_contact_people
				})
				this.$router.push({
					path: '/contact',
					query: {
						'enrolls': JSON.stringify(this.enrollsList.enrolls),
						'buyNum': JSON.stringify(this.buyNum)
					}
				})
			},
			onsubmit: _debounce(function(_type, index, item) {
				if (this.input_contact_name == '') {
					Toast('联系人姓名不能为空');
				} else if (this.input_contact_people == '') {
					Toast('联系人电话不能为空');
				} else if (!/^1[3456789]\d{9}$/.test(this.input_contact_people)) {
					Toast('请输入正确的手机号码');
				} else if (!localStorage.getItem('buyNuminfo')) {
					Toast('请填写游客信息');
				} else {
					// 购买数量
					var total_num = 0
					for (let i = 0; i < this.buyNum.length; i++) {
						total_num += this.buyNum[i].num
					}
					// 游客信息
					var people_array = []
					for (let i = 0; i < this.enrollsList.enrolls.length; i++) {
						if (this.buyNum[i].num > 1) {
							for (let j = 0; j < this.buyNum[i].num; j++) {
								if (this.buyNum[i].info[j] == undefined) {
									Toast('请补全游客信息');
									return
								} else {
									people_array.push({
										'enrollID': this.enrollsList.enrolls[i].id,
										'singlePrice': this.enrollsList.enrolls[i].price_01,
										'mobile': this.buyNum[i].info[j].tel,
										'enrollName': this.enrollsList.enrolls[i].enrollName,
										'cnName': this.buyNum[i].info[j].name
									})
								}

							}
						} else {
							people_array.push({
								'enrollID': this.enrollsList.enrolls[i].id,
								'singlePrice': this.enrollsList.enrolls[i].price_01,
								'mobile': this.buyNum[i].info[0].tel,
								'enrollName': this.enrollsList.enrolls[i].enrollName,
								'cnName': this.buyNum[i].info[0].name
							})
						}
					}

					let jsonData = {
						object: {
							topId: this.$platformid,
							claim_id: 1147,
							claim_orgid: 621,
							claim_topid: this.$platformid,
							claim_skcomp: this.$platformid,
							number: total_num,
							productType: 1,
							userID: '6719',
							occupyStatus: 3,
							remark: this.input_contact_desc,
							teamID: this.productList.id,
							favourable: [{
									price: 0,
									favMode: 1,
									title: '其他费用',
									mark: "",
								},
								{
									price: 0,
									favMode: 2,
									title: '整体优惠',
									mark: "",
								}
							],
							guests: people_array,
							platform: 3,
							settlementType: 0,
							planID: this.enrollsList.id,
							contact: JSON.stringify({
								Name: this.input_contact_name,
								Tel: this.input_contact_people
							}),
							orgID: '7448',
							payable: this.total_price
						}
					}
					this.$_post(
						this.$connectHttpDayun + '/order/fenxiao/api/orderinsertv2', jsonData
					).then(res => {
						if (res.isSuccess) {
							let orderJson = JSON.parse(res.result.details)
							for (let i = 0; i < people_array.length; i++) {
								people_array[i].teamOrderId = orderJson.OrderID
							}
							let sweet_submit_json = {
								teamOrder: {
									topId: this.$platformid,
									merchant_OrganizationId: this.$organizationId,
									teamId: this.productList.id,
									teamName: this.productList.title,
									teamSKUID: this.productListPackage.id,
									platform: 2,
									settlementType: 0,
									orderNumber: orderJson.OrderCode,
									productType: 1,
									payable: this.total_price,
									webUserId: Number(this.userInfo.userId),
									userId: 5812,
									orgId: 6975,
									occupyStatus: 3,
									number: total_num,
									contact: JSON.stringify({
										Name: this.input_contact_name,
										Tel: this.input_contact_people
									}),
									planId: this.enrollsList.id,
									remark: this.input_contact_desc,
									teamTravelers: people_array,
									ShareWebUserId: 0,
									bigId: 0
								}
							}

							this.connectSubmitSweet(sweet_submit_json, orderJson.OrderCode)
						} else {
							Toast(res.result.message);
							localStorage.removeItem('buyNuminfo');
							localStorage.removeItem('contactinfo');
						}
					})

				}

			}, 500),
			connectSubmitSweet(params, code) {
				this.$_posts(
					this.$connectHttpSweet + '/TeamOrder/CreateOrUpdate', params
				).then(res => {
					localStorage.removeItem('buyNuminfo');
					localStorage.removeItem('contactinfo');
					if (res.success) {
						this.$router.push({
							path: '/swimorder',
							query: {
								orderId: code
							}
						})

					} else {
						Toast('提交失败');
					}
				})
			},
			getData() {
				var jsonData = {
					packagecompany: "," + this.$platformid + ",",
					id: this.$route.query.id
				}
				this.$_post(
					this.$connectHttpDayun + '/team/api/teamgetfxwd', jsonData
				).then(res => {
					this.productList = res.object
					this.picturePath = res.object.pepeatpic[0].picturePath
					this.connectDate(res.object.package)
				})
			},
			// 操作 详情返回值
			connectDate(data) {
				let gctemplate = ''
				if (data[this.packegeSelectIndex].gctemplate.length == 0) {
					gctemplate = '0'
				} else {
					gctemplate = data[this.packegeSelectIndex].gctemplate[this.childIndex].id
				}

				var jsonData = {
					object: {
						packageID: data.length > 0 ? data[this.packegeSelectIndex].id : 0,
						gctemplate: gctemplate
					}
				}

				this.$_post(
					this.$connectHttpDayun + '/teamquery/get/wxapp/silist', jsonData
				).then(res => {
					res.objects = res.objects.sort((a, b) => a.date - b.date)
					this.model_date_f = res.objects
					this.productListPackage = data[this.packegeSelectIndex]
					var map = res.objects.filter(item => item.dateFormat == this.time)
					this.enrollsList = map[0]
				})
			},

		}
	}
</script>

<style>
	.person_title {
		display: flex;
		width: 100%;
		height: 184px;
		background-color: #f6f6f6;
		align-items: flex-start;
		justify-content: space-between;
		padding: 32px;
		box-sizing: border-box;
	}

	.person_title h2 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		font-weight: normal;
		font-size: 30px;
	}

	.person_title img {
		border-radius: 5px;
		width: 120px;
		height: 120px;
	}

	.person_origin {
		width: 100%;
		padding: 32px 32px 0 32px;
		box-sizing: border-box;
	}

	.person_origin span {
		width: 100%;
		display: flex;
		margin-bottom: 32px;
	}

	.person_origin label {
		width: 168px;
		font-size: 24px;

		color: #999;
	}

	.person_origin p {
		font-size: 24px;
		color: #333;
	}

	.personnum p {
		margin-right: 10px;
	}

	.person_info {
		width: 100%;
		border-bottom: 20px solid #f7f7f7;
		border-top: 20px solid #f7f7f7;
		padding: 32px;
		box-sizing: border-box;
	}

	.person_info h2 {
		font-size: 28px;
		width: 100%;
		padding-bottom: 32px;
	}

	.person .van-cell {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	.person .van-cell::after {
		left: 0;
		right: 0;
	}

	.person .van-cell--required::before {
		left: 150px;
	}

	.person .detailBottom span {
		width: 50%;
	}

	.person .detailBottom_pric {
		background-color: #fff;
	}

	.person .detailBottom_pric label {

		font-size: 42px;
		font-weight: bold;
		color: #ff5663;
		display: flex;
		align-items: baseline;
	}

	.person .detailBottom_pric font {
		font-size: 24px;
		color: #333;
		font-weight: normal;
	}

	.person_chuxing {
		width: 100%;
		padding: 32px;
		box-sizing: border-box;
	}

	.person_chuxing-title {
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #f7f7f7;
	}

	.person_chuxing-title h2 {
		font-size: 28px;
		padding-bottom: 20px;
	}

	.person_chuxing-title label {
		font-size: 24px;
		color: #ff5663;
	}

	.person_chuxing-content {
		width: 100%;
	}

	.person_chuxing-content section {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.person_chuxing-content label {
		display: flex;
		flex-direction: row;
		margin-right: 16px;
		margin-top: 16px;
	}

	.person_chuxing-content p {
		padding-left: 16px;
		padding-right: 16px;
		line-height: 40px;
		font-size: 24px;
		color: #fff;
		background-color: #333;
		border-top-left-radius: 5px;
		border-bottom-left-radius: 5px;
		border: 1px solid #333;
	}

	.person_chuxing-content font {
		padding-left: 16px;
		padding-right: 16px;
		line-height: 40px;
		font-size: 24px;
		background-color: #fff;
		color: #333;
		border-top-right-radius: 5px;
		border-bottom-right-radius: 5px;
		border: 1px solid #333;
	}
</style>